import {handleActions, createAction} from 'redux-actions';
import config from "appConfig";
import {api, checkEmptyObject, formatDate} from '../../../services';
import {AdminNote, AdminNoteParsed, AdminNotesList, AdminNotesListParsed, AdsSortOption} from '../../../models';
import { adminNotesAdminInterface, rootReducerInterface } from '../../../typings/interfaces';

const ADMIN_NOTES_GET = 'ADMIN_NOTES_GET';
const ADMIN_NOTES_CREATE = 'ADMIN_NOTES_CREATE';
const ADMIN_NOTES_UPDATE = 'ADMIN_NOTES_UPDATE';
const ADMIN_NOTES_DELETE = 'ADMIN_NOTES_DELETE';

const parseAdminNotesData = (creditsLog: AdminNote[]): AdminNoteParsed[] => {
  return creditsLog.map((note) => {
    return {
      id: note.id,
      userId: note.userId,
      userEmail: note.userEmail,
      userName: note.userName,
      note: note.note,
      entityId: note.entityId,
      createdAt: formatDate(note.createdAt, config.dateFormat),
      lastModifiedDate: formatDate(note.lastModifiedDate, config.dateFormat),
    }
  });
}

// Actions

// Get Admin Notes
export const getAdminNotes = createAction(
  ADMIN_NOTES_GET,
  async (
    queryParams,
    callback?: (adminNotes: AdminNotesListParsed | Boolean) => void
  ) => {

    const searchParams = {
      ...queryParams,
      sortOption: AdsSortOption.DateDesc,
      itemPerPage: config.maxAdPerPage / 4,
    }

    let adminNotes: AdminNotesList;
    try {

      adminNotes = await api.AdminNotes.list(searchParams);

      if (!checkEmptyObject(adminNotes)) {
        callback && callback(false);
        return null;
      }

      const data = {
        data: parseAdminNotesData(adminNotes.data),
        count: adminNotes.count,
        page: adminNotes.currentPage,
        nextPage: adminNotes.nextPage,
        previousPage: adminNotes.previousPage,
      }

      callback && callback(data);
      return data;
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

// Create Admin Note
export const createAdminNote = createAction(
  ADMIN_NOTES_CREATE,
  async (
    note: AdminNote,
    callback?: (adminNotes: Boolean) => void
  ) => {
    try {
      const adminNote = await api.AdminNotes.create(note);
      callback && callback(adminNote);   
    } catch (error) {
      callback && callback(false);
    }
  }
);

// Update Admin Note
export const updateAdminNote = createAction(
  ADMIN_NOTES_UPDATE,
  async (
    id: string,
    note: AdminNote,
    callback?: (adminNotes: Boolean) => void
  ) => {
    try {
      const adminNote = await api.AdminNotes.update(id, note);
      callback && callback(adminNote); 
    } catch (error) {
      callback && callback(false);
    }
  }
);

// selectors
export const selectAdminNotes = (state: rootReducerInterface) => state.admin.adminNotes;

// INITIAL STATE
const initialState: adminNotesAdminInterface = {
  notes: null
};

// REDUCERS
const adminNotesReducers = {
  getAdminNotes: (state: adminNotesAdminInterface, { payload }) => ({
    ...state,
    notes: !payload ? {} : payload
  })
};

export default handleActions(
  {
    [ADMIN_NOTES_GET]: adminNotesReducers.getAdminNotes,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/adminNotes.ducks.ts